import ukFlag from '../images/uk-flag.png';
import dutchFlag from '../images/dutch-flag.png';

const languages = [
    { code: 'en', label: 'English', flag: ukFlag },
    { code: 'nl', label: 'Nederlands', flag: dutchFlag },
];

export default languages;
